import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Table from "../../includes/tables/Table";
import ActionButton from "../../includes/buttons/ActionButton";
import CustomerCreateModal from "./CustomerCreateModal";
import editIcon from "../../../assets/image/icons/edit.svg";
import deleteIcon from "../../../assets/image/icons/delete-red.svg";
import { getAllCustomers, saveCustomers, deleteCustomer } from "../../../utils/localDB";
import { isOnlineMode } from "../../../utils/onlineStatus";

const CustomerPage = () => {
  const navigate = useNavigate();
  const [isCreateCustomerModal, setIsCreateCustomerModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  console.log(customers, "customers");

  const handleModalClose = () => setIsCreateCustomerModal(false);

  const deleteCustomer = async (id) => {
    try {
      if (isOnlineMode()) {
        
      await axios.delete(`/api/customers/${id}`);
      setCustomers(customers.filter((customer) => customer.id !== id));
      } else {
        await deleteCustomer(id);
        setCustomers(customers.filter((customer) => customer.id !== id));
      }
    } catch (error) {
      console.error("Error deleting customer:", error);
    }
  };

  useEffect(() => {
  async function fetchCustomers() {
    try {
      if (isOnlineMode()) {
        const { data } = await axios.get("/api/customers");
        setCustomers(data);
        await saveCustomers(data); // cache offline
      } else {
        const localData = await getAllCustomers();
        setCustomers(localData);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      setCustomers([]);
    } finally {
      setIsLoading(false); // ✅ always run after fetch
    }
  }
  fetchCustomers();
}, []);

  return (
    <Main>
      <Header>
        <Title>Customers</Title>
        <ButtonContainer>
          <ActionButton
            variant="import_black"
            label="Import"
            onClick={() => setIsCreateCustomerModal(true)}
          />
          <ActionButton
            variant="create_black"
            label="Add New"
            onClick={() => navigate("/customer-entry")}
          />
        </ButtonContainer>
      </Header>

      <Content>
        <LeftPanel>
          {isLoading ? (
            <p style={{ padding: "20px" }}>Loading customers...</p>
          ) : (
            <CustomerList>
              <Table
                columns={[
                  { label: "Customer Name", key: "name", sortable: true },
                  { label: "Phone", key: "phone" },
                  {
                    label: "Amount",
                    key: "amount",
                    sortable: true,
                    render: (row) => (
                      <Amount value={row.ledger_balance}>₹ {row.ledger_balance}</Amount>
                    ),
                  },
                  {
                    label: "Action",
                    key: "action",
                    render: (row) => (
                      <Action>
                        <img src={editIcon} alt="edit" />
                        <img src={deleteIcon} onClick={() => deleteCustomer(row.id)} alt="delete" />
                      </Action>
                    ),
                  },
                ]}
                data={customers}
                onRowClick={setSelectedCustomer}
                highlightRow={(row) => selectedCustomer?.id === row.id}
              />
            </CustomerList>
          )}

          <QuickTip>
            <p>
              Use Import Customer feature to{" "}
              <strong>quickly create parties.</strong>
            </p>
          </QuickTip>
        </LeftPanel>
      </Content>

      {isCreateCustomerModal && (
        <CustomerCreateModal
          approved_amount=""
          handleModal={handleModalClose}
        />
      )}
    </Main>
  );
};

export default CustomerPage;

/* styles here ... */


/* Styles */
const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid #e5e5e5;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
`;

const LeftPanel = styled.div`
  width: 100%;
  border-right: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
`;

const CustomerList = styled.div`
  flex: 1;
`;

const Amount = styled.span`
  color: ${({ value }) => (value < 0 ? "red" : "green")};
`;

const Action = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const IconButton = styled.button`
  border: none;
  background: transparent;
  padding: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`;

const QuickTip = styled.div`
  padding: 10px;
  font-size: 12px;
  color: #555;
  background: #e8fff4;
  border-top: 1px solid #e5e5e5;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;
